import React from 'react';

const BackIcon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5306 12.4694C10.6715 12.6103 10.7507 12.8014 10.7507 13.0006C10.7507 13.1999 10.6715 13.391 10.5306 13.5319C10.3897 13.6728 10.1986 13.7519 9.99938 13.7519C9.80012 13.7519 9.60902 13.6728 9.46813 13.5319L4.46812 8.53187C4.3982 8.4622 4.34273 8.3794 4.30487 8.28824C4.26702 8.19707 4.24753 8.09934 4.24753 8.00062C4.24753 7.90191 4.26702 7.80417 4.30487 7.71301C4.34273 7.62185 4.3982 7.53905 4.46812 7.46937L9.46813 2.46937C9.60902 2.32848 9.80012 2.24932 9.99938 2.24932C10.1986 2.24932 10.3897 2.32848 10.5306 2.46938C10.6715 2.61027 10.7507 2.80137 10.7507 3.00062C10.7507 3.19988 10.6715 3.39098 10.5306 3.53187L6.0625 8L10.5306 12.4694Z"
      fill="currentColor"
    />
  </svg>
);

export default BackIcon;
